import script from "./OidoQuantityInput.vue?vue&type=script&setup=true&lang=js"
export * from "./OidoQuantityInput.vue?vue&type=script&setup=true&lang=js"

import "./OidoQuantityInput.vue?vue&type=style&index=0&id=f327deac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f327deac"]])

export default __exports__